const clearRetractionItem = function ({ commit }) {
  commit("CLEAR_RETRACTION");

  return Promise.resolve(undefined);
};

export default clearRetractionItem;
